module.exports = __webpack_public_path__ + "img/ic-arrow-n-inactive.871693fd.svg";